import SpecificationDocument from './SpecificationDocument';
export default SpecificationDocument;
